import React, { ReactNode } from 'react'
import { DropdownContainer, ContainerButton, ButtonArea, Icon, DropDownIndicator } from './styles'

interface ButtonProps {
    classIcon: string
    onClick?: () => void
    dropdown: boolean
    children?: ReactNode
}
const Button = ({ classIcon, onClick, dropdown, children }: ButtonProps): JSX.Element => {
    return (
        <ContainerButton>
            <ButtonArea onClick={dropdown ? (): void => {
                // 
            }: onClick}>
                <Icon className={classIcon} />
                {dropdown ? <DropDownIndicator className={'fas fa-caret-down'} /> : null}
            </ButtonArea>
            {dropdown ? <DropdownContainer>{children}</DropdownContainer> : null}
        </ContainerButton>
    )
}

export default Button
